import React, { PropsWithChildren } from 'react';

import { DetailRow } from '../detail-row/DetailRow';
import { DetailRowLabel } from '../detail-row/DetailRowLabel';
import { DetailRowValue } from '../detail-row/DetailRowValue';

export const TaxImpactGainsAllowanceAnnualGainsAllowance: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <DetailRow>
      <DetailRowLabel>Annual gains allowance</DetailRowLabel>
      <DetailRowValue>{children}</DetailRowValue>
    </DetailRow>
  );
};
